<script>
import { mdiChevronLeft } from '@mdi/js'


export default {
    name: 'CrvAppPage',

    props: {
        title: {
            type: String,
            default: undefined,
        },

        shouldShowNavBack: {
            type: Boolean,
            default: true,
        },

        containerClasses: {
            type: String,
            default: 'pa-0 pa-sm-12',
            note: ` default padding of the container is 48px for smAndUp (tablet+) 
                    for xs (mobile) the padding is disabled because tables should have no padding/margins`,
        },

        headerClasses: {
            type: String,
            default: 'd-flex align-center pb-sm-12',
            note: 'header classess only applied on tablet+ and when title is passed in',
        },

        bodyClasses: {
            type: String,
            default: '',
        },
    },

    emits: ['click-back'],

    data() {
        return {
            mdiChevronLeft,            
        }
    },

    computed: {
    resolvedTitle() {
      const disabled = this.$route.meta?.isPageNameDisabled


      if (disabled === true) return undefined

      // disabled only on certain breakpoints
      if (Array.isArray(disabled)) {
        const currentBp = this.$vuetify.display.name // 'xs','sm','md','lg','xl'
        if (disabled.includes(currentBp)) return undefined
      }

      if (this.title) return this.title

      // fallback to route
      if (!this.$route || !this.$route.name) return undefined

      // try to translate route name
      return this.$t?.(`routes.${String(this.$route.name)}`) ? String(this.$route.name) : String(this.$route.name)
    },

    showHeader() {
      // only show header on smAndUp and when title is not disabled
      return this.$vuetify.display.smAndUp && !!this.resolvedTitle
    },
  },

    methods: {
        handleClickBack() {
            this.$emit('click-back')
        },
    },
}
</script>

<template>
  <v-container 
    class="crv-app-page" 
    :class="containerClasses"
    fluid
  >
    <v-row 
      v-if="showHeader"
      no-gutters
    >
      <v-col 
        :class="headerClasses"
      >
        <v-icon 
          v-if="shouldShowNavBack"
          size="x-large"
          color="base-gray-90"
          class="ml-n4"
          :icon="mdiChevronLeft"
          @click="handleClickBack"
        />
        <h1>
          {{ title }}
        </h1>
        <slot name="after-title" />
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col :class="bodyClasses">
        <slot />
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang='scss' scoped>
@use '@v3c/assets/styles/variables.scss' as *;

.crv-app-page {
    min-height: calc(100vh - #{$desktop-header-height});
}

</style>
